import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ScrollReveal from "./ScrollReveal";

export default function Layout({ children }) {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // let route paint, then scroll to anchor
      setTimeout(() => {
        const id = decodeURIComponent(hash.replace("#", ""));
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <ScrollReveal />
    </div>
  );
}
